import { ClickEvent } from "../../shared/types/event.types";
import { ITestableComponentProps } from "../../shared/types/testing.types";

export interface IDrawerProps extends ITestableComponentProps {
  isDrawerOpen: boolean;
  isMobile: boolean;
  onClose: (event: ClickEvent) => void;
}

export const DefaultDrawerProps = {
  isDrawerOpen: false,
  isMobile: false,
};
